// extracted by mini-css-extract-plugin
module.exports =  {"video":"styles-module_video__ZfcGaYgRaRNlJ29u10LG"};